export const ASSOCIATE_ASSIGNED_SUCCESS_TEXT =
  'Associate assigned successfully!';
